export default __webpack_public_path__ + "static/mobile-money-payment-solutions-92d575cdf86ea4df909fa50bf224f570.png";